import { delay as Tt } from "../../common-lib/utils/delay.js";
import { maskString as At } from "../../common-lib/utils/string.js";
import { ContractEventType as lt, DELAY_REFETCH_AFTER_CONTRACT_SUCCESS as yt, GAS_FEE_PRIORITY as Et } from "../constants/contract.js";
import Rt from "./graphql/useConfirmTransaction.js";
import It from "./useVerifyContractTransaction.js";
import { CurrencyTokenType as Ot } from "../../currency-lib/constants/currency.js";
import { ChainAddressType as St, ChainNetworkType as _t, ChainType as ut } from "../../temp-lib/constants/chain.js";
import { ContractOperation as S } from "../../temp-lib/constants/contract.js";
import { ERROR_CODE as C } from "../../temp-lib/constants/error.js";
import { RETRY as Pt } from "../../temp-lib/constants/retry.js";
import { ScreenLogType as mt } from "../../temp-lib/constants/screenLog.js";
import { WalletExtensionRdns as vt } from "../../temp-lib/constants/web3.js";
import { useAccountContext as Lt } from "../../temp-lib/contexts/account/AccountContext.js";
import { useMessageContext as Gt } from "../../temp-lib/contexts/share/MessageContext.js";
import { CustomError as A } from "../../temp-lib/errors/customError.js";
import Dt from "../../temp-lib/hooks/generic/useChainSwitcher.js";
import Wt from "../../temp-lib/hooks/generic/useScreenLog.js";
import kt from "../../temp-lib/hooks/web3/useWeb3.js";
import { isIosOrAndroid as Bt } from "../../temp-lib/util/browser/index.js";
import { isProduction as Ft } from "../../temp-lib/util/environment/index.js";
import { RoninVRFDescription as Mt, RoninVRFTitle as $t } from "../../wallet-lib/components/RoninVRFMessage.js";
import { MobileWalletSnackBarMode as xt } from "../../wallet-lib/constants/index.js";
import { useRoninWalletSnackBarContext as Ht } from "../../wallet-lib/contexts/RoninWalletSnackbarContext.js";
import Ut from "../../wallet-lib/hooks/useMktErrorHandling.js";
import bt from "../../wallet-lib/hooks/useWalletAddress.js";
import { getConnectors as qt, getAccount as v, connect as Jt, readContract as Vt, writeContract as Kt, waitForTransactionReceipt as Yt, reconnect as jt, getGasPrice as Qt, estimateGas as zt } from "@wagmi/core";
import Xt from "p-retry";
import * as s from "ramda";
import { useState as dt, useCallback as d } from "react";
import { useTranslation as Zt } from "react-i18next";
import { getAbiItem as pt, decodeEventLog as te, encodeFunctionData as ee } from "viem";
import { jsx as ft } from "react/jsx-runtime";
const We = (r) => {
  const {
    t: R
  } = Zt(), {
    intercept: L
  } = Wt(), {
    correctNetwork: M,
    validateWalletInstalled: $,
    wagmiConfig: W,
    manualReconnect: x
  } = kt(), {
    openSnackBar: H
  } = Ht(), {
    verify: U
  } = It(), {
    account: E,
    isLoggedIn: b,
    setWrongNetwork: q
  } = Lt(), {
    showErrorPopup: k
  } = Ut(), {
    compareAddress: J
  } = bt(), {
    mutate: V
  } = Rt(), {
    detectWalletType: K,
    getContractAbi: Y,
    getContractAddress: j,
    getChainImage: Q,
    getChainIdByType: z
  } = Dt(), [wt, X] = dt(!1), [gt, Ct] = dt(null), {
    showGeneralError: Z,
    setInfo: G,
    cleanInfo: p
  } = Gt(), h = d(() => {
    if (s.isNil(W))
      throw new A("wagmi config is null", C.CONTRACT.WAGMI_CONFIG_IS_NULL);
    return W;
  }, [W]), tt = d((t, e) => {
    switch (t.type) {
      case lt.REQUEST_ID:
        return s.pathOr("", [t.eventName, "returnValues", "_requestHash"], e);
      case lt.TRANSACTION_HASH:
        return s.pathOr("", [t.eventName, "transactionHash"], e);
      default:
        return "";
    }
  }, []), et = d(async (t, e, n, a, i) => {
    var m;
    const o = h(), l = qt(o);
    if (s.isNil(n) || s.isEmpty(n))
      throw new A("no method found", C.CONTRACT.SKIP_OPERATION);
    v(o).chainId !== z(St.RONIN) && $(_t.Ronin);
    const c = v(o);
    if (!await M())
      throw new A("wrong network (chain id)", C.LOGIN.WRONG_NETWORK);
    if (a === S.SEND) {
      if (!c.isConnected) {
        const _ = await ((m = o.storage) == null ? void 0 : m.getItem("recentConnectorId"));
        let w = null;
        for (const T of [_, vt.Ronin, "injected"])
          if (w = l.find((O) => O.id === T) ?? null, w)
            break;
        if (w)
          try {
            await Jt(o, {
              connector: w
            });
          } catch (T) {
            console.error(T);
          }
      }
      const I = v(o);
      if (!I.isConnected)
        throw new A("no connected account", C.LOGIN.CANNOT_GET_ACCOUNT_RESPONSE);
      if (!J(E.walletAddress, I.address))
        throw G({
          blocking: !0,
          confirm: R("common.popup.got_it"),
          icon: Q(i),
          message: R("wallet.switch_address"),
          tag: At(E.walletAddress || ""),
          title: R("wallet.wrong_address")
        }), new A("stored wallet address not match with current wallet address", C.CONTRACT.WALLET_ADDRESS_MISMATCH);
    }
    if (!pt({
      abi: t,
      name: n
    }))
      throw new A(`Method "${n}" not found on ${e}`, C.CONTRACT.METHOD_NOT_FOUND);
  }, [h, z, M, $, J, E.walletAddress, G, R, Q]), nt = d(async (t) => {
    const {
      contract: e
    } = t || {}, n = K(), a = Y((e == null ? void 0 : e.abi) || (r == null ? void 0 : r.abi), {
      walletType: n
    }), i = j((e == null ? void 0 : e.address) || (r == null ? void 0 : r.address), {
      walletType: n
    }), o = (e == null ? void 0 : e.method) || (r == null ? void 0 : r.method) || "";
    return {
      abi: a,
      address: i,
      method: o,
      walletType: n
    };
  }, [K, Y, j, r == null ? void 0 : r.abi, r == null ? void 0 : r.address, r == null ? void 0 : r.method]), ot = d(async (t, e, n, a, i) => {
    const o = h(), l = v(o), c = () => {
      var u;
      const f = s.pathOr(void 0, ["ronin", "value"], t);
      if (s.isNotNil((u = t.ronin) == null ? void 0 : u.gasLimit) && s.isNotNil(f)) {
        const y = BigInt(s.pathOr("0", ["balances", Ot.Ron, "amount"], E)), g = BigInt(f);
        if (y < g && t.isVrf)
          throw G({
            blocking: !0,
            confirm: R("common.popup.ok"),
            message: /* @__PURE__ */ ft(Mt, {
              skipDescription: !0
            }),
            title: /* @__PURE__ */ ft($t, {
              title: R("wallet.ronin.vrf.not_enough_balance")
            }),
            onConfirm: p
          }), new A("not enough balance", C.CONTRACT.NOT_ENOUGH_BALANCE_FOR_GAS_FEE);
      }
    }, N = async () => await Qt(o, {
      chainId: l.chainId
    }), m = async () => {
      var y, g;
      const f = s.pathOr(void 0, ["ronin", "gasLimit"], t);
      return s.isNotNil(f) ? f : await zt(o, {
        type: "legacy",
        account: l.address,
        to: n,
        value: (y = t == null ? void 0 : t.ronin) != null && y.value ? BigInt((g = t == null ? void 0 : t.ronin) == null ? void 0 : g.value) : void 0,
        data: ee({
          abi: e,
          functionName: a,
          args: i
        })
      });
    }, I = async () => !s.includes(E.chainType, [ut.Polygon, ut.PolygonTestnet]) ? null : Et, _ = () => {
      var f;
      return (f = t == null ? void 0 : t.ronin) == null ? void 0 : f.value;
    };
    c();
    const w = await N(), T = await m(), O = await I(), P = _();
    return {
      from: l.address,
      gasPrice: w,
      gas: BigInt(T),
      maxPriorityFeePerGas: O ? BigInt(O) : null,
      value: BigInt(P || "0")
    };
  }, [h, E, G, R, p]), rt = d((t) => {
    var a;
    const e = t.shortMessage || s.propOr("unknown error", "message", t), n = "Internal JSON-RPC error.";
    if (t.cause)
      return {
        code: (a = t.cause) == null ? void 0 : a.code,
        message: t.shortMessage
      };
    if (s.startsWith(n, e)) {
      const i = s.pipe(s.replace(n, ""), s.replace(`/
/g`, ""), JSON.parse), {
        code: o,
        message: l
      } = i(e);
      return {
        code: o,
        message: l
      };
    } else
      return {
        code: C.CONTRACT.UNSPECIFIED,
        message: e
      };
  }, []), at = d(async (t, e, n, ...a) => {
    const i = h();
    return await Vt(i, {
      address: t,
      abi: e,
      functionName: n,
      args: a
    });
  }, [h]), ct = d(async (t, e, n, a, ...i) => {
    var O, P, f;
    const o = h();
    console.group("contract"), console.info(`address: ${t}`), console.info(`method: ${n}
args:
 ${JSON.stringify(i, null, 2)}`), console.groupEnd();
    const l = a || {}, {
      callbacks: c,
      verifyEvent: N
    } = l, m = await ot(l, e, t, n, i), I = {
      abi: e,
      address: t,
      functionName: n,
      args: i,
      gasPrice: m.gasPrice || void 0,
      gas: m.gas || void 0,
      value: m.value || void 0,
      type: "legacy",
      __mode: "prepared"
    }, _ = Kt(o, I);
    Bt() && !window.ronin && !window.okxwallet && H(xt.SignTransaction), (O = c == null ? void 0 : c.onSent) == null || O.call(c, I);
    let w;
    try {
      const u = await _;
      if ((P = c == null ? void 0 : c.onTransactionHash) == null || P.call(c, u), w = await Yt(o, {
        hash: u
      }), console.group("contract"), console.info(`receipt:
 ${JSON.stringify(w, null, 2)}`), console.groupEnd(), (f = c == null ? void 0 : c.onReceipt) == null || f.call(c, w), u)
        try {
          await V(u);
        } catch (y) {
          console.error(y);
        }
    } catch (u) {
      throw console.group("contract"), console.info(`error:
${JSON.stringify(u, null, 2)}`), console.groupEnd(), u;
    }
    const T = w.logs.reduce((u, y) => {
      try {
        const g = te({
          abi: e,
          eventName: N == null ? void 0 : N.eventName,
          data: y.data,
          topics: y.topics
        });
        return g != null && g.eventName && (u[g.eventName] = {
          eventName: g.eventName,
          transactionHash: w.transactionHash,
          returnValues: g.args
        }), u;
      } catch {
        return u;
      }
    }, {});
    return s.isNotNil(T) && !s.isEmpty(T) && !s.isNil(N) && !await U({
      uniqueID: tt(N, T),
      uniqueIDType: N.type,
      eventName: N.eventName
    }) ? (Z("Unknown error(s) occured"), null) : (await Tt(yt), T);
  }, [h, ot, H, V, U, tt, Z]), st = d((t) => {
    if (s.is(A, t))
      return t;
    const {
      code: e,
      message: n
    } = rt(t);
    return new A(n, e);
  }, [rt]), it = d((t, e, n, a, ...i) => {
    console.error(t.stack);
    const o = st(t), l = Ft() ? "hidden on production" : i;
    switch (o.code) {
      case C.LOGIN.WRONG_NETWORK:
        b && q(a);
        return;
      case C.CONTRACT.SKIP_OPERATION:
        throw console.warn(`
Contract skipped:

Address: [${e}]

Method: [${n}]

Args: [${l}]
 
${o}`), o;
      case C.CONTRACT.USER_DENIED_TRANSACTION:
        throw k(o), o;
      default:
        throw k(o), console.error(`
Contract error:

Address: [${e}]

Method: [${n}]

Args: [${l}]
 
${o}`), o;
    }
  }, [b, st, q, k]), D = d(async (t, e, ...n) => {
    const a = h(), {
      abi: i,
      address: o,
      method: l,
      walletType: c
    } = await nt(e);
    if (!E.walletAddress) {
      if (t === S.SEND)
        throw new A("no wallet address found", C.CONTRACT.WALLET_ADDRESS_MISMATCH);
      return null;
    }
    v(a).isConnected || (S.CALL ? await jt(a) : await x());
    try {
      X(!0), await et(i, o, l, t, c);
      let m = null;
      switch (t) {
        case S.CALL: {
          m = await Xt(() => at(o, i, l, ...n), Pt.CONTRACT.DEFAULT);
          break;
        }
        case S.SEND: {
          m = await ct(o, i, l, e, ...n);
          break;
        }
      }
      return Ct(m), m;
    } catch (m) {
      it(m, o, l, c, ...n);
    } finally {
      X(!1);
    }
  }, [h, nt, E.walletAddress, x, et, at, ct, it]), B = d(async (t, ...e) => {
    var a;
    return L({
      input: e,
      operation: ((a = t == null ? void 0 : t.contract) == null ? void 0 : a.method) || (r == null ? void 0 : r.method),
      type: mt.Contract,
      runJob: D
    })(S.CALL, t, ...e);
  }, [L, D, r == null ? void 0 : r.method]), F = d(async (t, ...e) => {
    var a;
    return L({
      input: e,
      operation: ((a = t == null ? void 0 : t.contract) == null ? void 0 : a.method) || (r == null ? void 0 : r.method),
      type: mt.Contract,
      runJob: D
    })(S.SEND, t, ...e);
  }, [L, D, r == null ? void 0 : r.method]), Nt = d(async (...t) => B(null, ...t), [B]), ht = d(async (...t) => F(null, ...t), [F]);
  return {
    loading: wt,
    call: Nt,
    callWithOption: B,
    send: ht,
    sendWithOption: F,
    data: gt
  };
};
export {
  We as default
};
//# sourceMappingURL=useContract.js.map
